jQuery( document ).ready( function ( $ ) {
	const delay = 10;

	setTimeout( function () {
		$( '.single-product .ast-tab-header' ).removeClass( 'active' );
		$( '.single-product .wc-tab' )
			.removeClass( 'active' )
			.css( 'height', 0 );
		$( '.single-product .woocommerce-tabs' ).css( 'display', 'block' );
	}, delay );
} );
